import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/919092279193?text=Hello%20ProNest!%20I%20would%20like%20to%20inquire%20about%20your%20products."
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "50px",
        right: "15px",
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "32px",
        textDecoration: "none",
        zIndex: 999999,
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      }}
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppFloat;